export enum EnumPartnerReason {
  PRESENTATION_FOR_NEW_CLIENTS = "Apresentação recorrente para novos clientes",
  PRESENTATION_FOR_MY_BASE = "Apresentação recorrente para base",
  SPORADIC_BASE_WORK = "Trabalho na base esporádico",
  ON_DEMAND_SALES = "Vendas sob demanda",
  LEAVE_IT_IN_SHOWCASE = "Deixar na Vitrine",
  PUNCTUAL_SALE = "Venda Pontual",
}